import { render, staticRenderFns } from "./vipapplyfor.vue?vue&type=template&id=52189546&scoped=true&"
import script from "./vipapplyfor.vue?vue&type=script&lang=js&"
export * from "./vipapplyfor.vue?vue&type=script&lang=js&"
import style0 from "./vipapplyfor.vue?vue&type=style&index=0&id=52189546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52189546",
  null
  
)

export default component.exports